import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { useRouteMatch } from 'react-router-dom'
import { PageHeader } from 'components/page-header'
import GET_LESSON_CREDIT_BALANCE from './query'
import LessonPacksDisplay from './lesson-packs-display'
import LinearProgress from '@material-ui/core/LinearProgress'
import Error from 'components/error'
import { Tabs, Tab } from 'components/tabs'
import GiftLessonPackModal from './gift'
import { mapGiftedCreditBalances } from './gifted-lesson-credit-utils'

const isActivePurchasedLessonPack = ({ remainingCredits, expiresAt }) => {
  return (
    remainingCredits > 0 &&
    (expiresAt == null || Date.parse(expiresAt) > Date.now())
  )
}

const isPastPurchasedLessonPack = ({ remainingCredits, expiresAt }) => {
  return (
    remainingCredits === 0 || (expiresAt && Date.parse(expiresAt) < Date.now())
  )
}

const isActiveGiftedCreditBalance = ({
  remainingCredits,
  nextExpirationDate,
}) => {
  return (
    remainingCredits > 0 &&
    (nextExpirationDate == null || Date.parse(nextExpirationDate) > Date.now())
  )
}

const LessonPacksPageData = ({ selectedTab }) => {
  const { data, loading, error } = useQuery(GET_LESSON_CREDIT_BALANCE)
  const [giftingLessonPackId, setGiftingLessonPackId] = useState(null)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error error={error} />

  const lessonCreditBalances = data?.currentUser?.attributes?.lessonPacks || []
  const giftedLessonCreditBalances =
    data?.currentUser?.attributes?.giftedLessonCreditBalances || []

  const activeLessonPacks = lessonCreditBalances.filter(
    isActivePurchasedLessonPack,
  )

  const usedOrExpiredLessonPacks = lessonCreditBalances.filter(
    isPastPurchasedLessonPack,
  )

  const activeGiftedLessonCreditBalances = giftedLessonCreditBalances.filter(
    isActiveGiftedCreditBalance,
  )

  const activeGiftedLessonPacks = mapGiftedCreditBalances(
    activeGiftedLessonCreditBalances,
  )

  const handleGiftClick = lessonPackId => {
    setGiftingLessonPackId(lessonPackId)
  }

  const handleGiftClose = () => {
    setGiftingLessonPackId(null)
  }

  return (
    <>
      <LessonPacksDisplay
        selectedTab={selectedTab}
        activeLessonPacks={activeLessonPacks}
        activeGiftedLessonPacks={activeGiftedLessonPacks}
        usedOrExpiredLessonPacks={usedOrExpiredLessonPacks}
        onGiftClick={handleGiftClick}
      />

      <GiftLessonPackModal
        open={!!giftingLessonPackId}
        onClose={handleGiftClose}
        lessonPack={lessonCreditBalances.find(
          lp => lp.id === giftingLessonPackId,
        )}
      />
    </>
  )
}

const LessonPacksPage = () => {
  const { path } = useRouteMatch()
  const [selectedTab, setSelectedTab] = useState('active')

  const crumbs = [
    {
      label: 'My Coach',
      to: path
        .split('/')
        .slice(0, 2)
        .join('/'),
    },
  ]
  return (
    <>
      <PageHeader
        title="Lesson Packs"
        crumbs={crumbs}
        tabs={
          <Tabs
            value={selectedTab}
            onChange={(_, newValue) => setSelectedTab(newValue)}
          >
            <Tab label="Active" value="active" />
            <Tab label="Past" value="past" />
          </Tabs>
        }
      />
      <LessonPacksPageData selectedTab={selectedTab} />
    </>
  )
}

export default LessonPacksPage
